import { useEffect, useState } from "react";
import { client, MAINT_FA } from "../net/client";
import { useSignal } from "../net/signal";

/**
 * پرده‌ی تعمیرات.
 *
 * به‌جای toast، چون این *حالت* است و نه رویداد: تا وقتی سرور بسته است باید
 * روی صفحه بمانَد. toastِ قبلی سه ثانیه بود و بازیکنی که همان لحظه نگاه
 * نمی‌کرد، صفحه‌ای می‌دید که هیچ دکمه‌اش کار نمی‌کرد و هیچ دلیلی هم نداشت.
 *
 * تلاشِ دوباره هر شصت ثانیه خودش می‌رود. دکمه هم هست، برای کسی که حوصله
 * ندارد صبر کند.
 */
export function MaintenanceGate() {
  const msg = useSignal(client.maintenance);
  const [tryingAt, setTryingAt] = useState(0);

  useEffect(() => {
    if (!msg) return;
    const t = setInterval(() => { setTryingAt(Date.now()); void client.connect(); }, 60_000);
    return () => clearInterval(t);
  }, [msg]);

  if (!msg) return null;
  return (
    <div className="veil maintgate" role="alertdialog" aria-labelledby="maint-h">
      <div className="plate stack" style={{ gap: 12, maxWidth: 420 }}>
        <h2 id="maint-h">{MAINT_FA}</h2>
        {msg !== MAINT_FA && <p className="muted">{msg}</p>}
        <button
          className="btn"
          onClick={() => { setTryingAt(Date.now()); void client.connect(); }}
        >
          دوباره امتحان کن
        </button>
        <p className="muted" style={{ fontSize: 13 }}>
          {tryingAt ? "تلاش شد؛ هنوز بسته است." : "هر یک دقیقه خودش هم دوباره امتحان می‌کند."}
        </p>
      </div>
    </div>
  );
}
